import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user } = useAuth();
  if (user === null)
    return (
      <div className="min-h-screen flex items-center justify-center text-sm text-[var(--ink-2)]">
        Loading…
      </div>
    );
  if (!user) return <Navigate to="/login" replace />;
  return children;
}
